<!--
 * @Description:跟进记录
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-05-05 10:45:26
 * @LastEditors: cxh
-->
<template>
  <cos-table @fetch="fetch" serial :columns="columns" ref="table" :tableId="`${route.path}_TabsClueCosFollowUp`">
    <template #bodyCell="{ column, record, text }">
      <template v-if="column.dataIndex === 'startTime'">
        <p>{{ text }}~{{ record.endTime }}</p>
      </template>
      <template v-if="column.dataIndex === 'fbuProcess'">
        <p v-html="xss(record.process)"></p>
      </template>
      <template v-if="column.dataIndex === 'lbuProcess'">
        <p>跟进目的：{{ record.lbuPurpose }}</p>
        <p>跟进过程：{{ record.process }}</p>
        <p>后续：{{ record.result }}</p>
        <p>当前遇到的问题：{{ record.problem }}</p>
      </template>
    </template>
  </cos-table>
</template>
<script setup lang="ts">
import { computed, onMounted, reactive } from 'vue'
import type { PropType } from 'vue'
import { useRoute } from 'vue-router'
import type { ClueManage } from '@/typings/api/marketingManage'
import { fbuFollowRecordsList } from '@/api/gucangSales/followUpManage'
import { lbuFollowRecordsList } from '@/api/yuntuSales/followUpManage'
import { listByParamCodes } from '@/api/common'
import xss from 'xss'
const route = useRoute()
const props = defineProps({
  data: {
    type: Object as PropType<ClueManage>
  },
  appId: {
    type: String as PropType<'cos_zbu_fbu' | 'cos_zbu_lbu'>,
    default: 'cos_zbu_fbu'
  },
  followRefId: String
})
const paramCodeData = reactive<{
  follow_mode: []
  follow_purpose: []
}>({
  follow_mode: [], // 拜访方式
  follow_purpose: [] // 访客目的
})
const appIdEumn = {
  cos_zbu_fbu: 'cos_fbu',
  cos_zbu_lbu: 'cos_lbu'
}
const appIdPre = computed(() => {
  const eumn = {
    cos_zbu_fbu: 'fbu',
    cos_zbu_lbu: 'lbu'
  }
  return eumn[props.appId]
})

// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: appIdEumn[props.appId],
    paramCodes: [`${appIdPre.value}_follow_mode`, `${appIdPre.value}_follow_purpose`]
  }).then((res) => {
    if (res.code === 200) {
      paramCodeData.follow_mode = res.data[`${appIdPre.value}_follow_mode`]
      paramCodeData.follow_purpose = res.data[`${appIdPre.value}_follow_purpose`]
    }
  })
}
// 跟进记录
const fetch = async (params: object, callBack: (res: any) => void) => {
  try {
    if (!props.followRefId) {
      setTimeout(() => {
        callBack([])
      }, 500)
      return
    }
    let res: any = []
    if (appIdPre.value === 'fbu') {
      res = await fbuFollowRecordsList({
        ...params,
        followRefId: props.followRefId
      })
    } else if (appIdPre.value === 'lbu') {
      res = await lbuFollowRecordsList({
        ...params,
        followRefId: props.followRefId
      })
    }
    callBack(res)
  } catch (error) {
    console.log('error: ', error)
  }
}
const columns = computed(() => {
  const init = [
    { title: '跟进方式', dataIndex: 'mode', dicData: paramCodeData.follow_mode },
    { title: '跟进时间', dataIndex: 'startTime', width: 350 },
    {
      title: '具体详情',
      dataIndex: `${appIdPre.value}Process`,
      width: 350
    },
    { title: '创建人', dataIndex: 'createByName' },
    { title: '创建时间', dataIndex: 'createTime', width: 190 }
  ]
  if (appIdPre.value === 'fbu') {
    return [
      {
        title: '跟进目的',
        dataIndex: 'fbuPurpose',
        dicData: paramCodeData.follow_purpose
      },
      ...init
    ]
  } else {
    return init
  }
})
onMounted(() => {
  getByParamCodes()
})
</script>
<script lang="ts">
export default { name: 'ContactsTable' }
</script>
<style lang="scss" scoped></style>
